export default "__VITE_ASSET__BnFQl2oX__"